export const getBonusMinDeposit = (bonus: any, optionIndex = 0) =>
  bonus?.options?.[optionIndex]?.minDeposit;
